export var EmploymentStatus;
(function (EmploymentStatus) {
    EmploymentStatus["FullTime"] = "Full-Time";
    EmploymentStatus["PartTime"] = "Part-Time";
    EmploymentStatus["Unemployed"] = "Unemployed";
    EmploymentStatus["Retired"] = "Retired";
    EmploymentStatus["RetiredMilitary"] = "Retired Military";
    EmploymentStatus["ActiveMilitary"] = "Active Military";
    EmploymentStatus["Contract"] = "Contract / Temporary";
    EmploymentStatus["Student"] = "Student";
    EmploymentStatus["SelfEmployed"] = "Self-Employed";
    EmploymentStatus["Other"] = "Other";
})(EmploymentStatus || (EmploymentStatus = {}));
export var IncomeBasis;
(function (IncomeBasis) {
    IncomeBasis["Annually"] = "Annually";
    IncomeBasis["Monthly"] = "Monthly";
    IncomeBasis["Biweekly"] = "Biweekly";
    IncomeBasis["Weekly"] = "Weekly";
})(IncomeBasis || (IncomeBasis = {}));
export var ResidenceType;
(function (ResidenceType) {
    ResidenceType["OwnMortgage"] = "Own/Have Mortgage";
    ResidenceType["Rent"] = "Rent";
    ResidenceType["OwnNoMortgage"] = "Own/No Mortgage";
    ResidenceType["Military"] = "Military on Base";
    ResidenceType["Relative"] = "Live with Relative";
    ResidenceType["Other"] = "Other";
})(ResidenceType || (ResidenceType = {}));
export var VehicleType;
(function (VehicleType) {
    VehicleType["New"] = "New";
    VehicleType["Used"] = "Used";
    VehicleType["Cpo"] = "CPO";
    VehicleType["Demo"] = "DEMO";
})(VehicleType || (VehicleType = {}));
